import { useState, useEffect } from 'react';

import { fetchDataToken } from '../utils';
import { ServerUrl } from '../constants';
import ModalImageViewer from './ModalImageViewer';
import Loader from './Loader';

const Galeria = () => {
  const [categories, setCategories] = useState([]);
  const [imagesByCategory, setImagesByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewer, setViewer] = useState({ images: null, index: null });

  /* ===============================
     LOAD CATEGORIES
  ================================ */
  useEffect(() => {
    fetchDataToken('picture/categories', 'GET', null, (res) => {
      if (Array.isArray(res)) {
        setCategories(res);
      } else {
        setError('Не удалось загрузить категории');
      }
    });
  }, []);

  /* ===============================
     LOAD IMAGES BY CATEGORY
  ================================ */
  useEffect(() => {
    const loadImages = async () => {
      const allImages = {};

      for (const { category } of categories) {
        await new Promise((resolve) => {
          fetchDataToken(`picture/${category}`, 'GET', null, (res) => {
            allImages[category] = res?.pictures || [];
            resolve();
          });
        });
      }

      setImagesByCategory(allImages);
      setLoading(false);
    };

    if (categories.length > 0) {
      loadImages();
    }
  }, [categories]);

  /* ===============================
     VIEWER LOGIC
  ================================ */
    const openViewer = (category, index) => {
        // ⚠️ В модалке используем JPG (макс. совместимость)
        const imgs = (imagesByCategory[category] || []).map(
            (p) => `${ServerUrl}${p}.jpg`
        );
        setViewer({ images: imgs, index });
    };

    const closeViewer = () =>
        setViewer({ images: null, index: null });

    const prevImage = () =>
        setViewer((v) => {
        if (!v.images) return v;
            const nextIndex =
                (v.index - 1 + v.images.length) % v.images.length;
            return { ...v, index: nextIndex };
        });

    const nextImage = () =>
        setViewer((v) => {
            if (!v.images) return v;
            const nextIndex = (v.index + 1) % v.images.length;
            return { ...v, index: nextIndex };
        });

  /* ===============================
     RENDER
  ================================ */
    if (loading) return <Loader />;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="container-gallery pd-t-5p">
            {categories.map(({ category, label }) => (
                <div className="padd-b-3p" key={category}>
                <h2 className="text-centre-mobile">{label}</h2>

                <div className="gallery">
                    {imagesByCategory[category]?.length > 0 ? (
                    imagesByCategory[category].map((imgPath, index) => (
                        <picture key={index}>
                        {/* WebP для новых браузеров */}
                        <source
                            srcSet={`${ServerUrl}${imgPath}.webp`}
                            type="image/webp"
                        />

                        {/* JPG fallback */}
                        <img
                            src={`${ServerUrl}${imgPath}.jpg`}
                            alt={`${label} #${index}`}
                            className="image-in-gallery"
                            loading="lazy"
                            onClick={() => openViewer(category, index)}
                            style={{ cursor: 'pointer' }}
                        />
                        </picture>
                    ))
                    ) : (
                    <p>Brak obrazów w tej kategorii</p>
                    )}
                </div>
                </div>
            ))}

            <ModalImageViewer
                images={viewer.images}
                currentIndex={viewer.index}
                onClose={closeViewer}
                onPrev={prevImage}
                onNext={nextImage}
            />
        </div>
    );
};

export default Galeria;
